import { useCurrencyFormat } from './hooks/useCurrencyFormat';
import { useNumberFormat } from './hooks/useNumberFormat';
import { usePercentFormat } from './hooks/usePercentFormat';
import { ICurrency, IDecimal, IPercent } from './interfaces';

const Currency = ({
  currency = 'usd',
  maximumFractionDigits = 2,
  value,
}: ICurrency) => {
  const format = useCurrencyFormat({ currency, maximumFractionDigits });
  return format(value);
};
Currency.displayName = 'NumberValueFormatter.Currency';

const Percent = ({ maximumFractionDigits = 2, value }: IPercent) => {
  const format = usePercentFormat({ maximumFractionDigits });
  return format(value);
};
Percent.displayName = 'NumberValueFormatter.Currency';

const Decimal = ({ maximumFractionDigits = 0, value }: IDecimal) => {
  const format = useNumberFormat({ maximumFractionDigits });
  return format(value);
};
Decimal.displayName = 'NumberValueFormatter.Currency';

export { Currency, Percent, Decimal };
